module.exports = __webpack_public_path__ + "bf120f44e4e21db64619ffad0e9f9259.png";